<template>
<div
class="flex flex-col items-center  bg-white rounded-[20px] px-5 py-[30px] border border-gray-line"
>
<HeaderAvatar></HeaderAvatar>

<div class="grid grid-cols-[auto_auto] gap-3 items-center px-5 mt-3">
  <span
    class="font-normal text-[12px] leading-[14px] text-text-deep text-left"
    >{{ $t("header-account") }}：</span
  >
  <div class="flex items-center">
    <svg
      class="mr-1"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      v-if="userInfo.type === 0"
    >
      <path
        d="M11.525 6.2496C11.525 5.7871 11.4875 5.4496 11.4063 5.09961H6.125V7.18708H9.22497C9.1625 7.70585 8.825 8.4871 8.07499 9.01207L8.06447 9.08196L9.73431 10.3756L9.84999 10.3871C10.9125 9.40585 11.525 7.96209 11.525 6.2496Z"
        fill="#4285F4"
      />
      <path
        d="M6.12462 11.7498C7.64335 11.7498 8.91834 11.2498 9.84962 10.3873L8.07461 9.01227C7.59962 9.34352 6.9621 9.57477 6.12462 9.57477C4.63713 9.57477 3.37464 8.59355 2.9246 7.2373L2.85863 7.24291L1.12232 8.58666L1.09961 8.64978C2.0246 10.4873 3.9246 11.7498 6.12462 11.7498Z"
        fill="#34A853"
      />
      <path
        d="M2.92498 7.23715C2.80623 6.88716 2.7375 6.51213 2.7375 6.12465C2.7375 5.73713 2.80623 5.36214 2.91873 5.01214L2.91558 4.9376L1.15751 3.57227L1.09999 3.59963C0.718752 4.36214 0.5 5.2184 0.5 6.12465C0.5 7.0309 0.718752 7.88712 1.09999 8.64963L2.92498 7.23715Z"
        fill="#FBBC05"
      />
      <path
        d="M6.12462 2.67499C7.18086 2.67499 7.89334 3.13123 8.29961 3.51251L9.8871 1.9625C8.91213 1.05625 7.64335 0.5 6.12462 0.5C3.9246 0.5 2.0246 1.76249 1.09961 3.59998L2.91835 5.01249C3.37464 3.65625 4.63713 2.67499 6.12462 2.67499Z"
        fill="#EB4335"
      />
    </svg>

    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      v-if="userInfo.type === 1"
      class="mr-1"
    >
      <path
        d="M9.26989 6.36305C9.28672 8.17562 10.86 8.77878 10.8774 8.78648C10.8641 8.82899 10.626 9.64602 10.0486 10.4899C9.54935 11.2196 9.03122 11.9465 8.21503 11.9616C7.41312 11.9763 7.15522 11.486 6.23834 11.486C5.32173 11.486 5.03522 11.9465 4.27606 11.9763C3.48825 12.0062 2.88832 11.1874 2.38501 10.4604C1.35644 8.97345 0.57042 6.25851 1.62585 4.4259C2.15015 3.51581 3.08718 2.93954 4.10417 2.92476C4.87777 2.91002 5.60798 3.44522 6.0809 3.44522C6.55351 3.44522 7.44086 2.8016 8.3737 2.89611C8.76417 2.91238 9.8604 3.05383 10.5643 4.08415C10.5075 4.11931 9.25629 4.84773 9.26989 6.36309M7.76272 1.91234C8.18101 1.40606 8.4625 0.701295 8.3857 0C7.7828 0.0242286 7.05381 0.401752 6.62135 0.907733C6.23381 1.35585 5.89442 2.07303 5.986 2.76042C6.658 2.81242 7.34444 2.41893 7.76272 1.91234Z"
        fill="black"
      />
    </svg>
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      v-if="userInfo.type === 2"
      class="mr-1"
    >
      <path
        d="M6.94264 11.4999V6.48232H9.30129L9.65441 4.52686H6.94264V3.27837C6.94264 2.71223 7.16283 2.32637 8.29986 2.32637L9.75 2.3259V0.576969C9.49909 0.553225 8.63833 0.5 7.63691 0.5C5.54614 0.5 4.11475 1.41125 4.11475 3.0848V4.52692H1.75V6.48237H4.11467V11.5L6.94264 11.4999Z"
        fill="#1877F2"
      />
    </svg>

    <span
      class="font-Roboto-Bold font-bold text-[12px] leading-[14px] text-text-deep"
      >{{ name }}</span
    >
  </div>
  <span
    class="font-normal text-[12px] leading-[14px] text-text-deep text-left"
    >{{ $t("header-status") }}：</span
  >
  <div class="flex items-center">
    <span
      class="font-Roboto-Bold font-bold text-[12px] leading-[14px] text-text-deep"
      >{{ status }}</span
    >
    <span
      v-if="!isVip"
      class="ml-1 p-1 px-[10px] bg-mainColor rounded-full text-center text-white text-[11px] leading-[12px] cursor-pointer"
      @click="showBuyModal"
      >{{ $t("dialog-vip-subscribe") }}</span
    >
  </div>
  <span
    class="font-normal text-[12px] leading-[14px] text-text-deep text-left"
    >{{ $t("header-signUp") }}：</span
  >
  <div
    class="font-Roboto-Bold font-bold text-[12px] leading-[14px] text-text-deep"
  >
    {{ $dayjs(userInfo.createTime).format("DD-MM-YYYY") }}
  </div>
  <span
    v-if="isVip"
    class="font-normal text-[12px] leading-[14px] text-text-deep text-left"
    >{{ $t("header-expired") }}：</span
  >
  <div
    v-if="isVip"
    class="font-Roboto-Bold font-bold text-[12px] leading-[14px] text-text-deep"
  >
    {{ dayjs(userInfo.vipEndTime).format("DD-MM-YYYY") }}
  </div>
  <span
    class="font-normal text-[12px] leading-[14px] text-text-deep text-left"
    >{{ $t("header-profile") }}：</span
  >
  <div>
    <WebAvatar></WebAvatar>
  </div>
</div>
<div class="w-full h-px bg-gray-line mt-5 mb-3"></div>
<a
  class="rounded-[8px] bg-white hover:bg-btn-bg-hover inline-flex items-center pl-5 cursor-pointer h-8 w-full"
  v-show="isVip"
  :href="orderManageUrl"
  target="_blank"
>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.6171 0.600576L6.61711 0.60058L6.61796 0.596296L6.63691 0.5H9.37316L9.39255 0.597376L9.39254 0.597378L9.39314 0.600282L9.76823 2.42774C9.80238 2.59409 9.91861 2.73173 10.0769 2.79325C10.6209 3.00468 11.1299 3.29683 11.5869 3.65988C11.7193 3.76507 11.8959 3.7962 12.0563 3.74264L13.8901 3.13024L13.9992 3.09641L14.0562 3.19426L14.0562 3.19427L14.059 3.19903L15.3224 5.31228L15.3702 5.39436L15.3077 5.4489L13.8875 6.65679C13.7537 6.7706 13.6894 6.94628 13.7182 7.11958C13.7278 7.17762 13.7374 7.2332 13.7466 7.28683C13.792 7.55097 13.8292 7.76781 13.8292 7.99943C13.8292 8.23265 13.792 8.44878 13.7467 8.71225C13.7375 8.76614 13.7279 8.82202 13.7182 8.88042C13.6894 9.05372 13.7537 9.2294 13.8875 9.34321L15.3077 10.5511L15.3702 10.6056L15.3224 10.6878L14.059 12.8022L14.0589 12.8022L14.0562 12.8069L13.9996 12.904L13.8906 12.8699L12.0563 12.2574C11.8959 12.2038 11.7194 12.2349 11.587 12.3401C11.1299 12.7031 10.6208 12.9953 10.0768 13.2068C9.91859 13.2683 9.80237 13.4059 9.76823 13.5723L9.39314 15.3997L9.39313 15.3997L9.39255 15.4026L9.37316 15.5H6.63691L6.61796 15.4037L6.61798 15.4037L6.6171 15.3994L6.24085 13.572C6.20643 13.4048 6.08907 13.2667 5.9296 13.2057C5.38097 12.9961 4.87872 12.6981 4.41976 12.3382C4.28758 12.2345 4.11217 12.2041 3.95283 12.2574L2.11855 12.8699L2.01075 12.9036L1.95486 12.8071L1.95491 12.807L1.95117 12.8008L0.686937 10.688L0.639116 10.6056L0.701614 10.5509L2.12148 9.34451C2.25494 9.23111 2.31934 9.05616 2.29126 8.8833C2.28033 8.81606 2.26947 8.7523 2.25906 8.69117C2.21561 8.4361 2.17994 8.22668 2.17994 8.00057C2.17994 7.775 2.21542 7.56693 2.25875 7.31283C2.26925 7.25123 2.28022 7.18691 2.29126 7.11899C2.31933 6.94621 2.255 6.77133 2.12166 6.65793L0.701713 5.45029L0.638762 5.39521L0.687117 5.31167L1.95124 3.19795L1.95127 3.19797L1.9543 3.19277L2.01074 3.09576L2.11941 3.12922L3.95257 3.74255C4.11303 3.79624 4.28975 3.76513 4.42224 3.65988C4.87921 3.29683 5.38826 3.00468 5.93226 2.79325C6.09043 2.73177 6.20663 2.59426 6.24085 2.42804L6.6171 0.600576Z"
      stroke="black"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
    <path
      d="M9.79117 7.9991C9.79117 8.47309 9.60287 8.92767 9.26771 9.26283C8.93255 9.59799 8.47797 9.78628 8.00398 9.78628C7.52999 9.78628 7.07541 9.59799 6.74025 9.26283C6.40509 8.92767 6.2168 8.47309 6.2168 7.9991C6.2168 7.52511 6.40509 7.07053 6.74025 6.73537C7.07541 6.40021 7.52999 6.21191 8.00398 6.21191C8.47797 6.21191 8.93255 6.40021 9.26771 6.73537C9.60287 7.07053 9.79117 7.52511 9.79117 7.9991Z"
      stroke="black"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
  </svg>
  <span
    class="ml-2 text-[12px] leading text-text-deep leading-[12px]"
    >{{ $t("header-subscription") }}</span
  >
</a>

<a
  class="rounded-[8px] bg-white hover:bg-btn-bg-hover inline-flex items-center pl-5 cursor-pointer h-8 w-full"
  @click="onLogout"
>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.3996 7.99961L11.1996 11.4663M14.3996 7.99961L11.1996 4.79961M14.3996 7.99961H4.26628M8.53294 14.3996H1.59961V1.59961H8.53294"
      stroke="black"
    />
  </svg>

  <span
    class="ml-2 text-[12px] leading text-text-deep leading-[12px]"
    >{{ $t("header-logout") }}</span
  >
</a>
</div>
</template>
<script setup>
import { useMainStore } from "@/store/index";
const { locale, t } = useI18n();
const dayjs = useDayjs();
const mainStore = useMainStore();
const route = useRoute();
const router = useRouter();
const localePath = useLocalePath();
const { isNormalVip, isVip, isVipPro, isLogin } = useUserInfo();
const orderManageUrl = ref(
  "https://billing.stripe.com/p/login/bIYcQMfWFcc76VG5kk"
);
const loading = ref(false);

const logoUrl = computed(() => mainStore.userInfo?.logoUrl);
const userInfo = computed(() => mainStore.userInfo);
const name = computed(() => {
  if (mainStore.userInfo?.email) {
    return mainStore.userInfo.email || mainStore.userInfo.nickName;
  }
  return mainStore.userInfo.nickName || "";
});
onMounted(() => {
  const {
    public: { MODE },
  } = useRuntimeConfig();
  if (MODE === "pro") {
    orderManageUrl.value =
      "https://billing.stripe.com/p/login/bIYcQMfWFcc76VG5kk";
  } else {
    orderManageUrl.value =
      "https://billing.stripe.com/p/login/test_aEU6pO28c415e529AA";
  }
  if (typeof AWS === "undefined") {
    retryLoad();
  }
});
const status = computed(() => {
  if (isVip.value) {
    if (isNormalVip.value) {
      return "VIP";
    } else if (isVipPro.value) {
      return "Pro VIP";
    }
    return "Standard";
  }
  return "Standard";
});
function onLogout() {
  if (loading.value) {
    return;
  }
  loading.value = true;
  useApi
    .logout()
    .then((res) => {
      console.log(res);
      loading.value = false;
      const { code } = res;
      if (code != 0) {
        return;
      }
      mainStore.clearLogin();
      window.dispatchEvent(new CustomEvent("logoutEvent"));
      router.push(localePath({name: 'index'}))
    })
    .catch((e) => {
      loading.value = false;
    });
}
function showBuyModal() {
  if (isVip.value) {
    return;
  }
  mainStore.setVipFrom("header_vip");
  mainStore.setVisibleVipDialog(true);
  useLogEvent({ eventName: "header-vip" });
}
function retryLoad() {
  var scriptEle = document.createElement("script");
  scriptEle.src = "https://sdk.amazonaws.com/js/aws-sdk-2.1181.0.min.js";
  scriptEle.onload = function () {
    console.log("Script loaded successfully.");
  };
  scriptEle.onerror = function () {
    if (jsTryCount.value >= 4) {
      return;
    }
    jsTryCount.value++;
    console.log("Script loading failed. Retrying...");
    retryLoad();
  };
  document.body.appendChild(scriptEle);
}
</script>